import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { post } from "../../lib/request";
/**
 * CREATE alert user API
 * POST /api/v1/alert-user
 */
export const createAlertUser = createAsyncThunk(
  "alertUser/create",
  async (payload, { rejectWithValue }) => {
    try {

      const res = await post("alert-users", payload);

      return res;
    } catch (err) {
      console.error("❌ createAlertUser error:", err);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const alertUserCreateSlice = createSlice({
  name: "alertUserCreate",
  initialState: {
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetCreateAlertUserState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createAlertUser.pending, (state) => {
        state.loading = true;
        state.success = false;
      })
      .addCase(createAlertUser.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(createAlertUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetCreateAlertUserState } = alertUserCreateSlice.actions;
export default alertUserCreateSlice.reducer;
